import styled from 'styled-components';

import Layout from './Layout';

const LayoutWithBackground = styled(Layout)`
  background-color: ${({ theme }) => theme.palette.background.default};
`;

export default LayoutWithBackground;
